import React from 'react'
import { Tooltip, Menu, styled, Button } from '@mui/material'
import { approveRejectReviews } from '../../Controllers/userManagment/common'
import mainContext from '../../contexts/mainContext';
import { __snackBarSeverity } from '../../constants';

let statusMap = {
    Approve: "Approved",
    Reject: "Rejected",
    Pending: "Pending"
}

let statusBtnMap = {
    Approve: "status_active",
    Reject: "status_inactive",
    Pending: "status_pending",
    awaiting: "status_awaiting"
}

const ReviewCard = ({ comment, status, rating, postOn, revieweeInfo, reviewerInfo, city, reviewerName, id, callBack }) => {
    const { setSnackBar } = React.useContext(mainContext);

    /* Maintain menu reference */
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    /* Call snackbar */
    const callSnackBar = (msg, type) => {
        setSnackBar({
            status: true,
            text: msg,
            severity: __snackBarSeverity[type]
        });
    }

    /* Update Menu reference */
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    /* Close Menu */
    const handleClose = () => {
        setAnchorEl(null);
    };

    /* Update review status */
    const updateReviewStatus = async (status) => {
        const res = await approveRejectReviews({ status, id })
        handleClose()
        if (res.data.status === 200) {
            callBack(res.data.data.review)
            return callSnackBar(res.data.message, "success");
        } else {
            return callSnackBar(res.data.errors[0].message, "error");
        }

    }
    return (
        <>
            <List className="list_card">
                <div>
                    <div className={`list_card_status 
                    ${status === "Approve" ? statusBtnMap[status] :
                            status === "Reject" ? "status_awaiting" :
                                (status === "Pending" && rating <= 1) ? "status_inactive" :
                                    statusBtnMap[status]
                        }
                        `}>{statusMap[status] || "Pending"}</div>
                </div>
                <div>{rating || 0}</div>
                <div>{reviewerName || "NA"} / {reviewerInfo?.role || "NA"}</div>
                <div>{revieweeInfo?.firstName + " " + revieweeInfo?.lastName || "NA"} / {revieweeInfo?.role || "NA"}</div>
                <div>{reviewerInfo?.city}</div>
                <div>{postOn}</div>
                <div style={{ textAlign: "right" }}>
                    <Tooltip title="View comment">
                        <button className="list_card_view_btn" onClick={handleClick}>View</button>
                    </Tooltip>
                </div>
            </List>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <Container>
                    <p>{comment}</p>
                    <Actions>

                        {status === "Approve" ?
                            <Button variant="outlined" size='small' style={{ textTransform: "unset" }} onClick={() => updateReviewStatus("Reject")}>Reject</Button> :
                            status === "Reject" ?
                                <Button variant="contained" size='small' style={{ textTransform: "unset" }} onClick={() => updateReviewStatus("Approve")}>Approve</Button> :
                                <>
                                    <Button variant="contained" size='small' style={{ textTransform: "unset" }} onClick={() => updateReviewStatus("Approve")}>Approve</Button>
                                    <Button variant="outlined" size='small' style={{ textTransform: "unset" }} onClick={() => updateReviewStatus("Reject")}>Reject</Button>

                                </>
                        }
                    </Actions>
                </Container>
            </Menu>
        </>
    )
}

const Container = styled("div")`
    padding: 1rem;
    width  :300px;
    .my-2{
        margin-top: 1rem;
    }
`;
const Actions = styled("div")`
    margin-top: 1rem;
    display: flex;
    column-gap: 1rem;  
`;

export default ReviewCard

const List = styled("div")`
.header{
    font-family: "semi-bold";
}
  display: grid;
  column-gap: 0.7rem;
grid-template-columns: minmax(0,1fr) minmax(0,1fr) minmax(0,3.2fr) minmax(0,3.2fr) minmax(0,1.5fr) minmax(0,1.5fr) minmax(0,0.8fr);
  align-items: center;
  font-size:14px;
  .view-text{
    font-size:12px;
  }
`;